import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {
  GET_ALERTS,
  GET_CLIENT_BODY_MEASUREMENTS,
  GET_CLIENT_JOURNEY_ALL_TASKS,
  GET_CLIENT_JOURNEY_TASKS,
  GET_CLIENT_MY_WHY,
  GET_CLIENT_PLAN_DETAILS,
  GET_CLIENT_STARTDATE,
  GET_CLIENT_WEIGHT_GRAPH_DETAILS,
  GET_COACH_SHARE_PLAN,
  GET_FIRST_ORDER,
  GET_MSWL_HEALTH_ROOT_PROFILE,
  GET_MWL_HEALTH_ROOT_PROFILE,
  GET_ORDER,
  GET_ORDERS,
  GET_PROFILE,
  RESET_CLIENT_PROFILE,
  SET_ALERTS_STATE,
  SET_CLIENT_JOURNEY_STATE,
  SET_CLIENT_JOURNEY_TASKS_DATA,
  SET_CLIENT_NOTES_STATE,
  SET_ORDER_STATE,
  SET_ORDERS_STATE,
} from '/redux/action/client.action';
import setNotesState from '/redux/reducer/client/setNotesState';
import {withPayload} from '/util/reducer.util';

import authSignOut from './client/auth/signOut';
import getAlerts from './client/getAlerts';
import getBodyMeasurements from './client/getBodyMeasurements';
import {getClientJourneyAllTasks} from './client/getClientJourneyAllTasks';
import {getClientJourneyTasks} from './client/getClientJourneyTasks';
import getClientPlanDetails from './client/getClientPlanDetails';
import getCoachAlias from './client/getCoachAlias';
import getFirstOrder from './client/getFirstOrder';
import getInfo from './client/getInfo';
import getMSWLHR from './client/getMSWLHR';
import getMWLHR from './client/getMWLHR';
import getMyWhy from './client/getMyWhy';
import getOrder from './client/getOrder';
import getOrders from './client/getOrders';
import getStartDate from './client/getStartDate';
import getWeightGraph from './client/getWeightGraph';
import resetClientProfile from './client/resetClientProfile';
import setAlertsState from './client/setAlertsState';
import setClientJourneyState from './client/setClientJourneyState';
import {setClientJourneyTaskData} from './client/setClientJourneyTaskData';
import setOrdersState from './client/setOrdersState';
import setOrderState from './client/setOrderState';

const initialState = {
  allProfiles: {},
  allOrders: {},
  allOrdersMeta: {},
  allOrdersState: {},
  allOrderDetail: {},
  allOrderDetailState: {},
  allAlertsData: {},
  allAlertsState: {},
  clientJourneyTasks: {},
  firstOrderDetail: {},
  allClientJourneyState: {},
  allNotesState: {},
  allMwlData: {},
  allMswlData: {},
  allWeightGraphData: {},
  coachAlias: {},
};

export default handleActions(
  {
    [GET_PROFILE]: withPayload(getInfo),
    [GET_ORDERS]: withPayload(getOrders),
    [GET_ORDER]: withPayload(getOrder),
    [GET_FIRST_ORDER]: withPayload(getFirstOrder),
    [SET_ORDERS_STATE]: withPayload(setOrdersState),
    [SET_ORDER_STATE]: withPayload(setOrderState),
    [SIGN_OUT]: withPayload(authSignOut),
    [GET_ALERTS]: withPayload(getAlerts),
    [SET_ALERTS_STATE]: withPayload(setAlertsState),
    [GET_CLIENT_JOURNEY_ALL_TASKS]: withPayload(getClientJourneyAllTasks),
    [GET_CLIENT_JOURNEY_TASKS]: withPayload(getClientJourneyTasks),
    [SET_CLIENT_JOURNEY_TASKS_DATA]: withPayload(setClientJourneyTaskData),
    [SET_CLIENT_JOURNEY_STATE]: withPayload(setClientJourneyState),
    [RESET_CLIENT_PROFILE]: withPayload(resetClientProfile),
    [SET_CLIENT_NOTES_STATE]: withPayload(setNotesState),
    [GET_MWL_HEALTH_ROOT_PROFILE]: withPayload(getMWLHR),
    [GET_MSWL_HEALTH_ROOT_PROFILE]: withPayload(getMSWLHR),
    [GET_CLIENT_WEIGHT_GRAPH_DETAILS]: withPayload(getWeightGraph),
    [GET_CLIENT_BODY_MEASUREMENTS]: withPayload(getBodyMeasurements),
    [GET_CLIENT_STARTDATE]: withPayload(getStartDate),
    [GET_CLIENT_PLAN_DETAILS]: withPayload(getClientPlanDetails),
    [GET_CLIENT_MY_WHY]: withPayload(getMyWhy),
    [GET_COACH_SHARE_PLAN]: withPayload(getCoachAlias),
  },
  initialState,
);
